export enum ErknmMenuItemsIdsEnum {
  KNM_INFO = 'KNM_INFO',
  KNM_APPROVE_INFO = 'KNM_APPROVE_INFO',
  KNM_VERIFIED_PERSON = 'KNM_VERIFIED_PERSON',
  KNM_OBJECTS_INFO = 'KNM_OBJECTS_INFO',
  KNM_CHECKLIST_INFO = 'KNM_CHECKLIST_INFO',
  KNM_EVENT_SUBJECT = 'KNM_EVENT_SUBJECT',
  KNM_ACT = 'KNM_ACT',
  KNM_RESULT_DECISIONS = 'KNM_RESULT_DECISIONS',
  KNM_AGREEMENTS = 'KNM_AGREEMENTS',
  KNM_REPEAT_PASSPORTS = 'KNM_REPEAT_PASSPORTS',
  KNM_JUDGMENTS = 'KNM_JUDGMENTS',
  KNM_DOCUMENTS = 'KNM_DOCUMENTS',
  KNM_SIGN_INFO = 'KNM_SIGN_INFO',
  KNM_EPGU_NOTIFICATION = 'KNM_EPGU_NOTIFICATION',
  KNM_HISTORY = 'KNM_HISTORY',
  KNM_EXECUTION_HISTORY = 'KNM_EXECUTION_HISTORY',
  KNM_OTHER_INFO = 'KNM_OTHER_INFO',
  KNM_PREVIOUS = 'KNM_PREVIOUS',
  KNM_STATUS_EXCHANGE = 'KNM_STATUS_EXCHANGE',
  KNM_PLAN_HISTORY = 'KNM_PLAN_HISTORY',
  KNM_PLAN_HISTORY_CHANGES = 'KNM_PLAN_HISTORY_CHANGES',
  KNM_NOTIFICATION = 'KNM_NOTIFICATION',
}
